/**
 * @generated SignedSource<<60168c8eb35cdea3867b014cd997101b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselThumb_sortedPhoto$data = {
  readonly alt: string | null;
  readonly masterOrZoomPath: string | null;
  readonly " $fragmentType": "CarouselThumb_sortedPhoto";
};
export type CarouselThumb_sortedPhoto$key = {
  readonly " $data"?: CarouselThumb_sortedPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselThumb_sortedPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselThumb_sortedPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "dfd3eaf813447b00108d8e011a92a9ec";

export default node;
